<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('create_category') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-8
      .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('create_category') }}
      v-text-field.round-xl.mb-4.text-md(v-model="categoryName" :placeholder="$t('enter_category_name')" outlined hide-details)
    v-divider

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="save" :loading="isLoading" color="primary" depressed :disabled="categoryName.trim().length  === 0") {{ $t('save') }}
  
    .dialogs
      assign-category-services-dialog(v-if="showAssignDialog" :open.sync="showAssignDialog" :category="newCategory"  @assigned="doneAssigned" @cancel="doneAssigned")

</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import AssignCategoryServicesDialog from './AssignCategoryServicesDialog.vue'

export default {
  name: 'CreateCategoryDialog',
  components: { AssignCategoryServicesDialog },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    categoryName: '',
    showAssignDialog: false,
    newCategory: {}
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    save () {
      this.isLoading = true
      const params = {
        company: this.company.id,
        parent: null,
        app: 'clinic',
        name: this.categoryName
      }
      this.axios.post(`/product_categories/`, params)
        .then(resp => {
          this.newCategory = resp.data
          this.showAssignDialog = true
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    doneAssigned () {
      this.showDialog = false
      this.$emit('created')
    }
  }
}
</script>
